import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  ListShareApplications,
  ShareApplicationsdelete,
  ShareApplicationsBulkDelete,
  ShareApplicationsConvertMember,
} from "../store/slices/share-applications.js";
import Loader from "../common/Loader.jsx";
import { useDispatch } from "react-redux";
import Table from "../common/Table.jsx";
import AdminLayout from "./AdminLayout";
import { toast } from "react-hot-toast";
import UploadApplicationsPopup from "../common/UploadApplicationsPopup.jsx";
import { FaFileExcel } from "react-icons/fa";
import { excelShareApplicationsDownload } from "../common/ExcelDownload";

const MembersMaster = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem("user"));
  const id = user?.data?.profile_id;

  const [isLoading, setIsLoading] = useState(false);
  const [isPopupOpen, setPopupOpen] = useState(false);
  const [listshareapplications, setListShareApplications] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]); // Stores selected row IDs
  const [columns] = useState([
    { header: "Checkbox", field: "Checkbox" },
    { header: "Date of Receipt", field: "date_of_receipt" },
    { header: "Application No", field: "application_no" },
    { header: "Name", field: "name" },
    { header: "No of Shares Applied", field: "no_applied_share" },
    {
      header: "Actions",
      field: "actions",
      isAction: true,
      actionButtons: [
        { name: "Edit", className: "btn-default" },
        { name: "Delete", className: "btn-cancel" },
      ],
    },
  ]);

  const [pageSize, setPageSize] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleEdit = (item) => {
    navigate(`/share-applications/edit/${item.id ? item.id : null}`);
  };

  const handleUploadSuccess = () => {
    setPopupOpen(false); // Close the popup after upload
    fetchListShareApplications();
  };

  const handleOpenPopup = () => {
    setPopupOpen(true);
  };

  // Function to close the popup
  const handleClosePopup = () => {
    setPopupOpen(false);
  };

  const fetchListShareApplications = async () => {
    setIsLoading(true);
    dispatch(ListShareApplications({ profile_id: id }))
      .unwrap()
      .then((data) => {
        setIsLoading(false);
        setListShareApplications(data?.data);
      })
      .catch(({ message }) => {
        setIsLoading(false);
        setListShareApplications([]);
        console.log(message);
      });
  };
  useEffect(() => {
    fetchListShareApplications();
  }, []);

  const handleDelete = (item) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Share Application?",
    );
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(ShareApplicationsdelete({ id: item.id, profile_id: id }))
        .unwrap()
        .then(() => {
          setIsLoading(false);
          fetchListShareApplications(); // Refresh the invoice list
        })
        .catch(({ message }) => {
          // console.log(message)
          setIsLoading(false);
          toast.error(message);
        });
    }
  };

  const handleDeleteBulk = () => {
    if (!selectedRows || selectedRows.length === 0) {
      alert("Please select at least one Share Application.");
      return;
    }

    const confirmDelete = window.confirm(
      "Are you sure you want to delete the selected Share Applications?",
    );
    if (confirmDelete) {
      setIsLoading(true);
      dispatch(
        ShareApplicationsBulkDelete({ ids: selectedRows, profile_id: id }),
      )
        .unwrap()
        .then(() => {
          setIsLoading(false);
          setSelectedRows([]);
          setSelectAll(false);
          fetchListShareApplications();
        })
        .catch(({ message }) => {
          setIsLoading(false);
          toast.error(message);
        });
    }
  };

    const handleConvertMember = () => {
      const selectedApplications =
        selectAll && listshareapplications.length > 0
          ? listshareapplications.map((application) => application.id)
          : selectedRows;

      if (!selectedApplications || selectedApplications.length === 0) {
        alert("Please select at least one Share Application.");
        return;
      }

      const confirmConvert = window.confirm(
        "Are you sure you want to convert the selected Share Applications to members?",
      );

      if (!confirmConvert) {
        return;
      }

      setIsLoading(true);
      dispatch(
        ShareApplicationsConvertMember({
          application_ids: selectedApplications,
          profile_id: id,
        }),
      )
        .unwrap()
        .then((response) => {
          setIsLoading(false);
          setSelectedRows([]);
          setSelectAll(false);
          toast.success(
            response?.message ||
              "Share applications converted to members successfully",
          );
          fetchListShareApplications();
        })
        .catch(({ message }) => {
          setIsLoading(false);
          toast.error(message || "Failed to convert share applications");
        });
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter data based on search query
  const filteredParties = listshareapplications?.filter(
    (party) =>
      party?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.address?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.phone?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      party?.date_added?.toLowerCase()?.includes(searchQuery?.toLowerCase()),
  );
  const handleExcelDownload = () => {
    if (!listshareapplications || listshareapplications.length === 0) {
      alert("No data available for download.");
      return;
    }

    const selectedInvoices =
      selectAll && listshareapplications.length > 0
        ? listshareapplications.map((invoice) => invoice.id)
        : selectedRows;

    if (!selectedInvoices || selectedInvoices.length === 0) {
      alert("Please select at least one ShareApplications.");
      return;
    }

    const selectedData = listshareapplications.filter((invoice) =>
      selectedInvoices.includes(invoice.id),
    );

    if (selectedData.length === 0) {
      alert("No matching ShareApplications found.");
      return;
    }

    try {
      excelShareApplicationsDownload(selectedData, "ShareApplications.xlsx");
      toast.success("Downloading Excel file successfully!");
    } catch (error) {
      console.error("Error downloading Excel file:", error);
      alert("Failed to download the Excel file. Please try again.");
    }
  };

  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container-fluid">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">
                Share Applications Master
              </h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Registers</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Share Applications List
                </li>
              </ol>
            </div>
            <div className="d-flex justify-content-end">
              <button
                className="btn ripple btn-default"
                onClick={() => handleOpenPopup()}
              >
                Import Share Applications
              </button>
              <button
                className="btn ripple btn-default"
                onClick={() => navigate("/share-applications/create")}
              >
                Add Share Applications
              </button>
              <button
                className="btn ripple btn-default"
                onClick={handleExcelDownload}
              >
                Export Excel <FaFileExcel />
              </button>
              <button
                className="btn ripple btn-default"
                onClick={handleConvertMember}
              >
                Convert Member
              </button>
              <button
                className="btn ripple btn-cancel"
                onClick={handleDeleteBulk}
              >
                Delete Selected
              </button>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Table
                columns={columns}
                data={filteredParties}
                tableRef={tableRef}
                pageSize={pageSize}
                setPageSize={setPageSize}
                currentPage={currentPage}
                handleDelete={handleDelete}
                totalCount={filteredParties.length}
                onPageChange={handlePageChange}
                handleEdit={handleEdit}
                handleSearchChange={handleSearchChange}
                selectedRows={selectedRows}
                setSelectedRows={setSelectedRows}
                selectAll={selectAll}
                setSelectAll={setSelectAll}
              />
            </div>
          </div>
        </div>
      </div>
      <UploadApplicationsPopup
        open={isPopupOpen}
        onClose={handleClosePopup}
        onUpload={handleUploadSuccess}
      />
    </AdminLayout>
  );
};

export default MembersMaster;


